import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mtg-chips',
  templateUrl: './chips.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipsComponent {
  @Input()
  color: 'primary' | 'secondary' | 'bordered' = 'primary';

  @HostBinding('class.chips')
  get defaultClass() {
    return true;
  }

  @HostBinding('class.chips--color-primary')
  get primaryColorClass() {
    return this.color === 'primary';
  }

  @HostBinding('class.chips--color-secondary')
  get secondaryColorClass() {
    return this.color === 'secondary';
  }

  @HostBinding('class.chips--color-bordered')
  get borderedColorClass() {
    return this.color === 'bordered';
  }
}
